module.exports = __webpack_public_path__ + "static/media/poster.46ef7b82.jpg";